module.exports = __webpack_public_path__ + "static/media/sunarch_3.e03acd2f.gif";